<section class="page-layout simple left-sidebar inner-sidebar inner-scroll">
  <div class="uds-page-title" [@animate]="{value:'*',params:{delay:'100ms',x:'-25px'}}">
    {{ 'header.user_menu.user_settings_txt' | translate }}
  </div>

  <dp-new-settings class="uds-page-content-fill"></dp-new-settings>

</section>